import type { Language } from "./finance.ts";

// A fixed, bounded set avoids constructing Intl for every cell/chart tick.
const locales = { id: "id-ID", en: "en-US" } as const;
const options = {
  date: { day: "2-digit", month: "short", year: "numeric" },
  dateTime: { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" },
  month: { month: "long", year: "numeric" }, shortMonth: { month: "short" },
  time: { hour: "2-digit", minute: "2-digit", second: "2-digit" },
} as const;
export type DateDisplay = keyof typeof options;
const currencies = new Map<Language, Intl.NumberFormat>();
const dates = new Map<string, Intl.DateTimeFormat>();
export function currencyFormatter(language: Language) {
  let formatter = currencies.get(language);
  if (!formatter) { formatter = new Intl.NumberFormat(locales[language], { style: "currency", currency: "IDR", maximumFractionDigits: 0 }); currencies.set(language, formatter); }
  return formatter;
}
export function formatRupiah(value: number, language: Language) { return currencyFormatter(language).format(value); }
export function dateFormatter(language: Language, display: DateDisplay) {
  const key = `${language}:${display}`;
  let formatter = dates.get(key);
  if (!formatter) { formatter = new Intl.DateTimeFormat(locales[language], options[display]); dates.set(key, formatter); }
  return formatter;
}
